// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.breadcrumb {
  padding: 0;
}
.breadcrumb .breadcrumb-item {
  color: var(--blue-dark);
}
.breadcrumb .breadcrumb-item > a {
  color: var(--blue-dark);
}
.breadcrumb .breadcrumb-item:not(:first-child):before {
  content: url(/assets/svg/icons/keyboard_arrow_right.svg);
  margin: 3px 0;
}
.breadcrumb .breadcrumb-item.active {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/breadcrumb/breadcrumb.component.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAAI;EACI,uBAAA;AAER;AADQ;EACI,uBAAA;AAGZ;AADQ;EACI,wDAAA;EACA,aAAA;AAGZ;AADQ;EACI,iBAAA;AAGZ","sourcesContent":[".breadcrumb {\n    padding: 0;\n    & .breadcrumb-item {\n        color: var(--blue-dark);\n        & > a {\n            color: var(--blue-dark);\n        }\n        &:not(:first-child):before {\n            content: url(/assets/svg/icons/keyboard_arrow_right.svg);\n            margin: 3px 0;\n        }\n        &.active {\n            font-weight: bold;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
